module.exports = __webpack_public_path__ + "static/tat-32-04a373051690d489288f95b7f18e8bb1.jpg";